module.exports = __webpack_public_path__ + "img/slogo.cab05bc2.png";